export default __webpack_public_path__ + "static/aboutus3-480-eefad7c426955c49f1f139df1d2e9950.png";